import React from 'react';
import CONFIG from '../../../config';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import 'dayjs/locale/fr';
import dayjs from 'dayjs';
import WidgetProgress from '../../../components/widgets/WidgetProgress';
import { IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';


function TrelloCard({ state, setState, id, user }) {
  const navigate = useNavigate();
  return (
    <>
      {state[id] &&
        <>
          <div className='col-span-1 grow-0 w-full text-center p-2 mt-2 bg-white hover:border-ame-orange my-shadow cursor-pointer' onClick={() => window.open(CONFIG.BASE_URL + "/intranet/fiche/" + state[id]._id, '_blank').focus()}>
            <div className='w-full grid-cols-12 grid text-left'>
              <div className='col-span-12'>
                {(!(user?.roles?.role_admin_read || user?.roles?.role_admin_write) && state[id]?.dossier?.id_commercial !== user?._id) ? (state[id]._id) : (<>{state[id].nom} {state[id].prenom}</>)}
              </div>
              <div className='col-span-12 text-sm'>
                Secteur : {state[id].dossier.secteur_recherche.charAt(0).toUpperCase() + state[id].dossier.secteur_recherche.slice(1)}
              </div>
              <div className='col-span-12 text-sm'>
                {state[id].dossier.type_facturation}
              </div>
              {state[id].dossier.etat === 'incomplet' &&
                <div className='col-span-12'>
                  <WidgetProgress variant="determinate" value={state[id].dossier.avancement_dossier * 100.} />
                </div>
              }
              {state[id].dossier.distance_secteur && state[id].dossier.distance_secteur < 90 &&
                <div className='col-span-12 text-ame-orange text-sm'>
                  <WarningIcon fontSize='small'></WarningIcon><span className='text-black'> {parseFloat(state[id].dossier.distance_secteur).toFixed(2)} km du secteur</span>
                </div>
              }
              {(state[id].dossier.etat !== 'incomplet' && state[id].dossier.avancement_dossier_hors_garant < 1) &&
                <div className='col-span-12 text-ame-orange text-sm'>
                  <WarningIcon fontSize='small'></WarningIcon><span className='text-black'> Dossier non complet</span>
                </div>
              }
              {(state[id].dossier.etat !== 'incomplet' && state[id].dossier.avancement_dossier < 1 && state[id].dossier.avancement_dossier_hors_garant === 1) &&
                <div className='col-span-12 text-ame-orange text-sm'>
                  <WarningIcon fontSize='small'></WarningIcon><span className='text-black'> Garant(s) non complet(s)</span>
                </div>
              }
              {state[id].dossier.list_garants.length === 0 &&
                <div className='col-span-12 text-ame-orange text-sm'>
                  <WarningIcon fontSize='small'></WarningIcon><span className='text-black'> Pas de garants</span>
                </div>
              }
              <div className='col-span-12 text-xs text-left'>
                {state[id].dossier.etat === 'incomplet' && ("Innactif depuis " + dayjs(state[id].date_derniere_connexion).diff(dayjs(), 'day') + " jour(s)")}
                {state[id].dossier.etat === 'complet' && "À vérifier "}
                {state[id].dossier.etat === 'verifie' && "À attribuer "}
                {state[id].dossier.etat === 'attribue' && "En recherche "}
                {state[id].dossier.etat === 'valide' && "Validé "}
                {state[id].dossier.etat === 'envoye' && "Envoyé organisme "}
                {state[id].dossier.etat !== 'incomplet' && ("depuis " + dayjs(state[id].date_dernier_changement_etat).diff(dayjs(), 'day') + " jour(s)")}
              </div>

              {state[id].dossier.dossiers_propose.map(x => x.id_commercial).includes(user?._id) &&
                <>
                  <div className='col-span-12 text-xs text-left flex items-center'>
                    <div className='text-xs'>Accepter proposition</div>
                    <div className=''>
                      <IconButton size='small'
                        onClick={(e) => {
                          e.stopPropagation();

                          axios.post(CONFIG.API_URL + '/api/deproposition_client_commercial/' + state[id]._id + '/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                            .then((response) => {
                              switch (response.status) {
                                case 200:
                                  let x = state;
                                  // x[id] = response.data
                                  x.splice(id, 1);
                                  setState(x);
                                  break;

                                default:
                                  break;
                              }
                            })
                            .catch((e) => {
                              let response = e.response;

                              if (response === undefined) {
                                alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                return;
                              }

                              switch (response.status) {
                                default:
                                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                  break;
                              }
                            });
                        }}
                      ><CancelIcon className='text-red-500'></CancelIcon></IconButton>
                    </div>

                    <div className='pr-4'>
                      <IconButton size='small'
                        onClick={(e) => {
                          e.stopPropagation();

                          axios.post(CONFIG.API_URL + '/api/attribution_client_commercial/' + state[id]._id + '/' + user._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                            .then((response) => {
                              switch (response.status) {
                                case 200:
                                  let x = state;
                                  x[id] = response.data
                                  setState(x);
                                  break;

                                default:
                                  break;
                              }
                            })
                            .catch((e) => {
                              let response = e.response;

                              if (response === undefined) {
                                alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                return;
                              }

                              switch (response.status) {
                                default:
                                  alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                                  break;
                              }
                            });
                        }}
                      ><CheckCircleIcon className='text-green-500'></CheckCircleIcon></IconButton>
                    </div>
                  </div>
                </>
              }
            </div>
          </div>
        </>
      }
    </>
  );
}

export default TrelloCard;